import script from "./Operation.vue?vue&type=script&setup=true&lang=js"
export * from "./Operation.vue?vue&type=script&setup=true&lang=js"

import "./Operation.vue?vue&type=style&index=0&id=5c1bc6ab&lang=scss&scoped=true"

import exportComponent from "C:\\IdeaWork\\Dweb2024\\store-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c1bc6ab"]])

export default __exports__